import { render, staticRenderFns } from "./SalesmanDetailsModal.vue?vue&type=template&id=a5e9ba98"
import script from "./SalesmanDetailsModal.vue?vue&type=script&lang=js"
export * from "./SalesmanDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./SalesmanDetailsModal.vue?vue&type=style&index=0&id=a5e9ba98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports